var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center is-shadowed"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":"/images/sdsa-logo-lg.png","alt":""}})]),(_vm.$route.path != '/')?_c('h1',{staticClass:"is-size-5"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("FOWLER FAMILY AWARDS CENTER")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }